<template>
  <div class=" is-fullwidth">
    <div class="level">
        <div class="level-left">
          <div class="columns" >
              

             <div class=" col">
                <input type="date" class="input" v-model="start_date" />
                
              </div>
              <div class=" pl-2 col" >
                <input type="date" class="input" v-model="end_date" />
                
              </div>

              <div class="pl-2 col">
                  <table class="table is-hoverable is-bordered " id="overviewtable" >
                    <tbody>
                      <tr>
                        <td class="">Total  Orders</td>
                        <td>{{ orders.length }}</td>
                      
                        </tr>
                    </tbody>
                  </table>
                </div>
            </div>
      </div>
        
      </div>
    
   

    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" >
    	<thead>
    		<tr>
        <th>PO Number</th>
        <th>Delivery Date</th>
        <th>Customer</th>
        <th>Garment</th>
        <th>Design</th>
          <th>Quantity</th>
        
   	 	    </tr>
    	</thead>
    	<tbody>
		    <tr v-if="orders_loading===true">
          <td colspan="10"><strong>Loading orders ...</strong></td>
          </tr>
        <tr v-for="order in orders" v-bind:key="order.orderID" v-show="orders_loading===false">
          <td >{{order.ponumber}}</td>
          <td >{{order.deliverydate}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
           <td>{{order.designname}}</td>
          
           <td>{{ order.total_qty }}</td>
        
			</tr>
      </tbody>
      
    </table>

    <button @click="exportXLS()" class="button is-info" >Export to Excel</button>

     
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
//import SalesService from '@/services/SalesService.js';
import XLSX from 'xlsx';

export default {
  name:'EarlyOrders',
  components: {
   	
  },
  data() {
    return {
      client_id: 21463,
       clients: [],
      orders: [],
      users: [],
      username: '',
      start_date: this.getStartDate(),
        end_date: new Date().toISOString().slice(0,10),
      currentSort: 'count',
      currentSortDir: 'desc',
      
     accessToken: '',
     clients_loading:true,
     orders_loading:true,
     VUE_APP_ASP_URL:process.env.VUE_APP_ASP_URL,

     range: '',
     
    }
  },
  created() {
      this.getAccessToken()
        .then(() => { 
            this.getOrders()
        });
      
    },
  methods: {
    async getAccessToken() {
        this.accessToken = await this.$auth.getTokenSilently()
    },
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'Customer Orders.xlsx')

	 },
   
    async getOrders() {
      this.orders_loading=true;
      OrderService.getOrders(this.accessToken, this.client_id, this.range, this.start_date, this.end_date, "", 1)
          .then(
            (orders => {
              
              this.$set(this, "orders", orders);
              this.orders_loading=false;
            }).bind(this)
          );
    },
    
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 62);
            return d.toISOString().slice(0,10);
             
        },
   
  },
  computed : {
     
     
  },

 
  mounted() {
    
  },
  watch: {
   
    start_date: function () {
     
      this.getOrders()
    },
    end_date: function () {
     
      this.getOrders()
    },
  }
}



</script>


